import { LoginForm } from './loginForm/loginForm';
import { ForgotPassword } from './forgotPassword/forgotPassword';

import template from './loginModal.html';
import './loginModal.scss';

export const LoginModal = angular
    .module('checkout.components.loginModal', [
        LoginForm,
        ForgotPassword
    ]).service('loginModalService', (modalService) => {
        return {
            open: ($event, initEmail, message) => {
                return modalService.open({
                    $event,
                    template: `
                        <login-modal
                            ${initEmail && `init-email="${initEmail}"`}
                            ${message && `message="${message}"`}>
                        </login-modal>`,
                    cssClass: 'login-modal',
                    clickOutsideToClose: false
                });
            }
        };
    }).component('loginModal', {
        bindings: {
            initEmail: '@',
            message: '@'
        },
        template,
        controller: class LoginModalCtrl {
            onForgotPasswordClicked(email) {
                this.forgotPasswordEmail = email;
                this.showForgotPassword = true;
            }

            onCancelForgotPasswordClicked() {
                this.showForgotPassword = false;
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/loginModal/loginModal.js